export default [
  {
    content: "롤러기 작업 전에는 안전점검을 실시",
    isChecked: "",
  },
  {
    content: "롤러기의 시동 후 3분간 기계의 상태를 주의깊게 관찰한 후 안전작업기준에 따라 작업을 수행",
    isChecked: "",
  },
  {
    content: "2인 이상의 협동작업인 경우 의사전달은 확실한 방법으로 실시",
    isChecked: "",
  },
  {
    content: "롤러기 작업 중에는 주유, 분해,∙ 수리 등 위험한 행위 금지",
    isChecked: "",
  },
  {
    content: "롤러기에는 안전작업을 해치는 환경 조성 금지",
    isChecked: "",
  },
  {
    content: "작업자의 복장은 단정히 하여 말려들 위험이 없어야 함",
    isChecked: "",
  },
  {
    content: "작업이 끝난 후 기계의 정비점검 및 청소 등 정리 정돈 실시 및 주요정비 점검 기록의 유지·관리",
    isChecked: "",
  },
  {
    content: "정비점검을 실시할 때에는 시동스위치에 잠금장치를 하고 “점검 중”, “사용금지” 등 표지판 부착",
    isChecked: "",
  },
  {
    content: "기계주변에 이물질이 있는지 확인",
    isChecked: "",
  },
  {
    content: "작업자 이외의 사람이 기계 주변에 있는지 확인",
    isChecked: "",
  },
  {
    content: "롤의 간격을 제품치수에 적합한 간격으로 조정",
    isChecked: "",
  },
  {
    content: "배관라인의 오일 누유 여부를 확인",
    isChecked: "",
  },
  {
    content: "급유상태가 양호한지 확인",
    isChecked: "",
  },
  {
    content: "원료 작업량이 적정하게 준비되었는지 확인",
    isChecked: "",
  },
  {
    content: "롤러기 가동과 관련한 조작스위치를 정지위치에 두고 기동스위치를 차단",
    isChecked: "",
  },
  {
    content: "롤 마모여부, 누유상태, 오일게이지 급유상태, 동작부 풀림상태 등을 점검",
    isChecked: "",
  },
  {
    content: "치공구 및 원부자재 등을 정리한 후 작업일지를 작성",
    isChecked: "",
  },
];
